import React from 'react'
import { MainLayout } from 'containers'
import { RecentlyPlayedWithRollout } from './RecentlyPlayedWithRollout'

const RecentlyPlayed = () => (
  <MainLayout content={<RecentlyPlayedWithRollout />} />
)

export default RecentlyPlayed
